import firebase from 'firebase'

export const email = {
  actions: {
    async sendEmail (state, payload) {
      /*
       * Sample payload:
       * { to, cc, bcc, subject, body }
      */
      const send = firebase.functions().httpsCallable('sendEmail')
      try {
        const sent = await send(payload)
        return sent
      } catch (err) {
        return err
      }
    }
  }
}
